document.addEventListener('DOMContentLoaded', function(){
  var wrap = document.getElementById('MrTabSwitch');
  if(!wrap) return;
  var mySection = wrap.closest('.shopify-section');
  if(!mySection) return;

  var sib1 = mySection.nextElementSibling;              // Recently viewed products
  var sib2 = sib1 ? sib1.nextElementSibling : null;      // Product recommendations
  if(!sib1 || !sib2) return;

  var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-mr-tab]'));
  var panels = { 0: sib2, 1: sib1 };

  function show(idx){
    tabs.forEach(function(t){
      t.classList.toggle('is-active', t.getAttribute('data-mr-tab') === String(idx));
    });
    Object.keys(panels).forEach(function(key){
      panels[key].style.display = (key === String(idx)) ? '' : 'none';
    });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.getAttribute('data-mr-tab')); });
  });

  show(0);
});